/**
 * Extracts position, rotation, and scale values from a GLTF transformation matrix.
 * @param {Array<number>} transformationMatrix - The transformation matrix.
 * @returns {{ xPos: number, yPos: number, rotation: number, scaleX: number, scaleY: number, scaleZ: number } | false}
 * The extracted transformation values, or false if extraction fails.
 */
export const extractPositionValues = (
  transformationMatrix?: Array<number>,
): { xPos: number; yPos: number; rotation: number; scaleX: number; scaleY: number; scaleZ: number } | false => {
  if (transformationMatrix === undefined || transformationMatrix.length !== 16) {
    return false;
  }

  // Extraction (x, y)
  const xPos = transformationMatrix[12];
  const yPos = -transformationMatrix[14];

  // Rotation as radians (Yaw)
  const rotation = Math.atan2(transformationMatrix[8], transformationMatrix[0]);

  // Scale extraction (length of basis vectors)
  const scaleX = Math.sqrt(transformationMatrix[0] ** 2 + transformationMatrix[1] ** 2 + transformationMatrix[2] ** 2);
  const scaleY = Math.sqrt(transformationMatrix[4] ** 2 + transformationMatrix[5] ** 2 + transformationMatrix[6] ** 2);
  const scaleZ = Math.sqrt(transformationMatrix[8] ** 2 + transformationMatrix[9] ** 2 + transformationMatrix[10] ** 2);
  return {
    xPos,
    yPos,
    rotation,
    scaleX,
    scaleY,
    scaleZ,
  };
};
